import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList } from "vue";
const _hoisted_1 = {
    key: 0,
    style: { "display": "none" },
    onload: "resizeTextarea('reply',3)"
};
const _hoisted_2 = { class: "footerFixed" };
const _hoisted_3 = {
    id: "all_wrapper",
    class: "question_answer ans_1"
};
const _hoisted_4 = { class: "wrapper_1" };
const _hoisted_5 = { class: "t_lead" };
const _hoisted_6 = { class: "name" };
const _hoisted_7 = { class: "comment_box" };
const _hoisted_8 = { class: "c_inner" };
const _hoisted_9 = { class: "prof" };
const _hoisted_10 = { class: "prof_ranking" };
const _hoisted_11 = {
    key: 0,
    class: "img_rank"
};
const _hoisted_12 = {
    class: "heart",
    style: { "margin-left": "6px" }
};
const _hoisted_13 = { class: "right" };
const _hoisted_14 = { class: "ca_1" };
const _hoisted_15 = { class: "ca_2" };
const _hoisted_16 = { class: "ph" };
const _hoisted_17 = { class: "comment" };
const _hoisted_18 = { class: "lock_wrapper" };
const _hoisted_19 = {
    key: 0,
    class: "self"
};
const _hoisted_20 = {
    key: 0,
    class: "word",
    style: { "white-space": "pre-line" }
};
const _hoisted_21 = ["id"];
const _hoisted_22 = { class: "date" };
const _hoisted_23 = { key: 0 };
const _hoisted_24 = {
    class: "bt_change modal_win",
    "data-target": "modal_del"
};
const _hoisted_25 = { key: 1 };
const _hoisted_26 = {
    key: 1,
    style: { "height": "32.39px", "margin": "30px auto" }
};
const _hoisted_27 = {
    key: 1,
    class: "self"
};
const _hoisted_28 = {
    key: 0,
    class: "word",
    style: { "white-space": "pre-line" }
};
const _hoisted_29 = ["id"];
const _hoisted_30 = { class: "date" };
const _hoisted_31 = ["onClick"];
const _hoisted_32 = {
    key: 2,
    class: "other"
};
const _hoisted_33 = { class: "ph" };
const _hoisted_34 = { class: "w_box" };
const _hoisted_35 = {
    key: 0,
    class: "word",
    style: { "white-space": "pre-line" }
};
const _hoisted_36 = ["id"];
const _hoisted_37 = { class: "date" };
const _hoisted_38 = ["onClick"];
const _hoisted_39 = {
    key: 1,
    class: "other"
};
const _hoisted_40 = { class: "ph" };
const _hoisted_41 = { class: "w_box" };
const _hoisted_42 = {
    class: "word",
    style: { "white-space": "pre-line" }
};
const _hoisted_43 = { class: "date" };
const _hoisted_44 = {
    key: 0,
    class: "alert"
};
const _hoisted_45 = {
    id: "plus",
    class: "plus"
};
const _hoisted_46 = ["placeholder"];
const _hoisted_47 = ["disabled"];
const _hoisted_48 = {
    id: "modal_del",
    class: "modal min2 js-modal"
};
const _hoisted_49 = { class: "modal-content" };
const _hoisted_50 = { class: "close_bt bt_modal_close" };
import { ref, reactive, watch, computed, onMounted, onUnmounted, onBeforeMount, nextTick } from 'vue';
import { Link } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia';
import axios from 'axios';
import moment from 'moment';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import PageExitConfirm from '@util/PageExitConfirm';
import InertiaUtil from '@util/InertiaUtil';
import Formatter from '@util/Formatter';
import { AuthRole } from '@util/Consts';
import { getServerTime, isNullOrWhiteSpace } from '@util/Common';
import { tryJsonForObject, isSuccessResponse } from '@util/Common';
import ImageFrame from '@component/ImageFrame.vue';
const showUnreadSecs = 5;
export default /*@__PURE__*/ _defineComponent({
    __name: 'question_answer_detail',
    props: {
        common: {},
        answer: {},
        errors: {},
        remaining_reply_count: {}
    },
    setup(__props) {
        var _a, _b, _c;
        const props = __props;
        // 未読メッセージ最初のID取得
        const unreadId = (_c = (_b = (_a = props.answer.replys) === null || _a === void 0 ? void 0 : _a.find(value => !value.is_read && value.user.id !== props.common.user_id)) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null;
        const showUnreadLine = ref(true);
        // 未読の表示時間（秒）
        let showUnreadTimeoutId = null;
        const content = ref('');
        const isTimeOver = ref(false);
        const rewrite = reactive({
            id: null,
            content: '',
        });
        // 通信中か判定
        const processing = ref(false);
        const checkPartyRole = computed(() => {
            if (props.common.user_id === props.answer.user.id) {
                return props.common.role === AuthRole.MENTOR;
            }
            if (props.common.user_id === props.answer.question.user.id) {
                return props.common.role === AuthRole.QUESTIONER;
            }
            return false;
        });
        const showReplyForm = computed(() => {
            var _a;
            // 相談者・回答者本人であり、返信可能回数が残っていて、無効化されていない場合に返信可能
            let isParty = false;
            let isCountOver = false;
            // 今はデータ内に回答者のユーザIDとしかないのでこれを使って判定、理想は相談者・メンターとデータ取得を分けて判定した方がわかりやすい？
            const answer = props.answer;
            if (props.common.role === AuthRole.MENTOR) {
                isParty = answer.user.id === props.common.user_id;
            }
            else if (props.common.role === AuthRole.QUESTIONER) {
                isParty = answer.question.user.id === props.common.user_id;
                isCountOver = ((_a = props.remaining_reply_count) !== null && _a !== void 0 ? _a : 0) <= 0;
            }
            const isTimeOverForReply = (!answer.id && !isTimeOver.value) || (answer.id && !props.answer.question.ended_at);
            return checkPartyRole.value && isTimeOverForReply && isParty && !isCountOver && !answer.locked && !props.answer.question.ended_at && !props.answer.question.locked;
        });
        const disableReply = computed(() => {
            return isNullOrWhiteSpace(content.value);
        });
        watch(() => content.value, (value) => {
            // 文字数チェック
            if (Alert.charLimitTextArea(value, 4000)) {
                content.value = value.substring(0, 4000);
            }
            // 編集チェック
            if (0 < value.length) {
                PageExitConfirm.addEvent();
            }
            else {
                PageExitConfirm.removeEvent();
            }
        });
        watch(() => rewrite.content, (value) => {
            // 文字数チェック
            if (Alert.charLimitTextArea(value, 4000)) {
                rewrite.content = value.substring(0, 4000);
            }
            resetTextarea(rewrite.id);
        });
        const showDestroy = () => {
            var _a;
            // メンターか判定
            const isMentor = ((_a = props.common['auth.user']) === null || _a === void 0 ? void 0 : _a.role) === AuthRole.MENTOR;
            return checkPartyRole.value && !isTimeOver.value && isMentor && !props.answer.is_parent_read && !props.answer.locked;
        };
        const onClickDestroy = () => {
            if (showUnreadTimeoutId) {
                clearTimeout(showUnreadTimeoutId);
            }
            Inertia.delete(route('question.answer.destroy', { question_id: props.answer.question.id, answer_id: props.answer.id }));
        };
        const showEdit = (id, isRead, replyId) => {
            // 今はデータ内に回答者のユーザIDとしかないのでこれを使って判定、理想は相談者・メンターとデータ取得を分けて判定した方がわかりやすい？
            const isAnswer = id === props.common.user_id;
            const isEdit = replyId === rewrite.id;
            return checkPartyRole.value && !isTimeOver.value && isAnswer && !isRead && !isEdit && !props.answer.locked;
        };
        const onClickSetEdit = (id, value) => {
            rewrite.id = id;
            rewrite.content = value;
            PageExitConfirm.addEvent();
            nextTick(() => resetTextarea(id));
        };
        const onClickCancelEdit = () => {
            PageExitConfirm.removeEvent();
            rewrite.id = null;
            rewrite.content = '';
        };
        const formatRegistered = (date) => {
            return Formatter.formatDate(date, 'YYYY年MM月DD日 HH:mm');
        };
        const showPlaceholder = () => {
            if (props.common.role === AuthRole.QUESTIONER) {
                return `返信コメントを入力（残り${props.remaining_reply_count}回まで）`;
            }
            else {
                return '返信コメントを入力';
            }
        };
        const onClickReturn = () => {
            Inertia.get(route('question.show', { id: props.answer.question.id }));
        };
        let sendProcessing = false;
        const onReply = () => {
            PageExitConfirm.removeEvent();
            const form = InertiaUtil.getForm({ content: content.value });
            const options = { preserveScroll: false, preserveState: (page) => 0 < Object.keys(page.props.errors).length };
            if (sendProcessing)
                return;
            sendProcessing = true;
            InertiaUtil.post(form, route('question.answer.store', { question_id: props.answer.question.id, answer_id: props.answer.id }), () => { sendProcessing = false; }, options);
        };
        const onRewrite = () => {
            PageExitConfirm.removeEvent();
            // パラメータが揃っていなければ、処理させない
            if (!rewrite.id || isNullOrWhiteSpace(rewrite.content))
                return;
            const form = InertiaUtil.getForm({ content: rewrite.content });
            const options = { preserveScroll: false, preserveState: (page) => 0 < Object.keys(page.props.errors).length };
            InertiaUtil.put(form, route('question.answer.update', { question_id: props.answer.question.id, answer_id: rewrite.id }), () => { }, options);
        };
        // いいねイベント
        const onClickHeart = () => {
            if (!props.answer.is_liked) {
                if (processing.value)
                    return;
                processing.value = true;
                // いいねを登録する
                axios.post(route('question.answer.like', { question_id: props.answer.question.id, answer_id: props.answer.id }))
                    .then(response => {
                    const res = tryJsonForObject(response);
                    if (isSuccessResponse(res.status)) {
                        props.answer.is_liked = true;
                        props.answer.like_count++;
                    }
                    else {
                        location.reload();
                    }
                }).finally(() => { processing.value = false; });
            }
            else {
                // いいねを取り消す
                axios.post(route('question.answer.like', { question_id: props.answer.question.id, answer_id: props.answer.id }))
                    .then(response => {
                    const res = tryJsonForObject(response);
                    if (isSuccessResponse(res.status)) {
                        props.answer.is_liked = false;
                        props.answer.like_count--;
                    }
                    else {
                        location.reload();
                    }
                });
            }
        };
        // メッセージ編集用にテキストエリアのサイズを調整する処理
        const resetTextarea = (id) => {
            if (!id)
                return;
            const textarea = document.getElementById(`textarea_${id}`);
            if (!textarea)
                return;
            const scrollHeight = textarea.scrollHeight;
            textarea.style.height = `${scrollHeight}px`;
            textarea.addEventListener('input', () => {
                textarea.style.height = `${textarea.scrollHeight}px`;
            });
        };
        const toggleLock = () => {
            const form = InertiaUtil.getForm({});
            InertiaUtil.post(form, route('question.answer.disable', { question_id: props.answer.question.id, answer_id: props.answer.id }));
        };
        onBeforeMount(() => {
            // 期限が過ぎているか判定
            if (props.errors !== '') {
                Alert.Error(props.errors);
                location.href = '/question';
            }
            getServerTime().then(res => {
                var _a, _b;
                if (res) {
                    const df = moment(new Date(res)).format('YYYY-MM-DD');
                    const dateFrom = moment(df);
                    const dt = moment((_b = (_a = props.answer.question) === null || _a === void 0 ? void 0 : _a.deadline) !== null && _b !== void 0 ? _b : null).format('YYYY-MM-DD');
                    const dateTo = moment(dt);
                    isTimeOver.value = dateTo.isBefore(dateFrom);
                }
            });
        });
        onMounted(() => {
            // 未読ラインを時間経過で消す
            showUnreadTimeoutId = setTimeout(() => {
                var _a;
                showUnreadLine.value = false;
                if ((_a = props.answer) === null || _a === void 0 ? void 0 : _a.id) {
                    axios.post(route('question.answer.read', { question_id: props.answer.question.id, answer_id: props.answer.id }));
                }
                showUnreadTimeoutId = null;
            }, 1000 * showUnreadSecs);
            nextTick(() => {
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
            });
        });
        onUnmounted(() => {
            PageExitConfirm.removeEvent();
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                (showReplyForm.value)
                    ? (_openBlock(), _createElementBlock("iframe", _hoisted_1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, _toDisplayString(props.answer.user.name) + "さんの回答", 1)
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                            (props.answer.question.ended_at)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    (props.answer.evaluation_ranking && props.answer.evaluation_ranking < 3)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                            _createVNode(ImageFrame, {
                                                                src: `images/common/i_rank_${props.answer.evaluation_ranking}.svg`
                                                            }, null, 8, ["src"])
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("p", _hoisted_12, [
                                                        _createElementVNode("i", {
                                                            class: _normalizeClass([props.answer.is_liked ? 'fas' : 'far', "fa-heart"]),
                                                            onClick: _withModifiers(onClickHeart, ["prevent"]),
                                                            style: { "cursor": "pointer" }
                                                        }, null, 2),
                                                        _createTextVNode(_toDisplayString(props.answer.like_count), 1)
                                                    ])
                                                ], 64))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("div", _hoisted_14, _toDisplayString((_b = (_a = props.answer.user) === null || _a === void 0 ? void 0 : _a.industry) === null || _b === void 0 ? void 0 : _b.name), 1),
                                            _createElementVNode("div", _hoisted_15, _toDisplayString((_g = (_e = (_d = (_c = props.answer.user) === null || _c === void 0 ? void 0 : _c.job_group) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : (_f = props.answer.user) === null || _f === void 0 ? void 0 : _f.other_job_name) !== null && _g !== void 0 ? _g : 'その他'), 1),
                                            _createVNode(_unref(Link), {
                                                class: "name",
                                                href: `/user/${props.answer.user.id}`
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(props.answer.user.name), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["href"]),
                                            _createElementVNode("div", _hoisted_16, [
                                                _createVNode(ImageFrame, {
                                                    src: props.answer.user.photo
                                                }, null, 8, ["src"])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass({ lock: props.answer.locked })
                                            }, null, 2),
                                            (props.answer.content)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                    (((_h = props.answer) === null || _h === void 0 ? void 0 : _h.id) !== rewrite.id)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString((_j = props.answer) === null || _j === void 0 ? void 0 : _j.content), 1))
                                                        : _createCommentVNode("", true),
                                                    (((_k = props.answer) === null || _k === void 0 ? void 0 : _k.id) === rewrite.id)
                                                        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                                            key: 1,
                                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((rewrite.content) = $event)),
                                                            id: `textarea_${(_l = props.answer) === null || _l === void 0 ? void 0 : _l.id}`,
                                                            style: { "white-space": "pre-line", "font-size": "1.8rem" }
                                                        }, null, 8, _hoisted_21)), [
                                                            [_vModelText, rewrite.content]
                                                        ])
                                                        : _createCommentVNode("", true),
                                                    _createElementVNode("div", _hoisted_22, [
                                                        (!isTimeOver.value)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                                _createTextVNode(_toDisplayString(formatRegistered(props.answer.created_at)) + " ", 1),
                                                                (showEdit((_m = props.answer) === null || _m === void 0 ? void 0 : _m.user.id, (_o = props.answer) === null || _o === void 0 ? void 0 : _o.is_parent_read, (_p = props.answer) === null || _p === void 0 ? void 0 : _p.id))
                                                                    ? (_openBlock(), _createElementBlock("a", {
                                                                        key: 0,
                                                                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => { var _a, _b; return (onClickSetEdit((_a = props.answer) === null || _a === void 0 ? void 0 : _a.id, (_b = props.answer) === null || _b === void 0 ? void 0 : _b.content)); }, ["prevent"])),
                                                                        class: "bt_change"
                                                                    }, " 編集 "))
                                                                    : _createCommentVNode("", true),
                                                                (((_q = props.answer) === null || _q === void 0 ? void 0 : _q.id) === rewrite.id)
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                        _createElementVNode("a", {
                                                                            class: "bt_change",
                                                                            onClick: _withModifiers(onRewrite, ["prevent"])
                                                                        }, "返信"),
                                                                        _createElementVNode("a", {
                                                                            class: "bt_change",
                                                                            onClick: _withModifiers(onClickCancelEdit, ["prevent"])
                                                                        }, "キャンセル")
                                                                    ], 64))
                                                                    : _createCommentVNode("", true),
                                                                _withDirectives(_createElementVNode("a", _hoisted_24, "削除", 512), [
                                                                    [_vShow, showDestroy()]
                                                                ])
                                                            ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(formatRegistered(props.answer.created_at)), 1))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_r = props.answer) === null || _r === void 0 ? void 0 : _r.replys, (reply) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                    (props.answer.is_parent_read && !reply.is_read && reply.id === _unref(unreadId))
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            (showUnreadLine.value)
                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                    key: 0,
                                                                    class: "unread",
                                                                    onClick: _cache[2] || (_cache[2] = ($event) => (showUnreadLine.value = false))
                                                                }, _cache[6] || (_cache[6] = [
                                                                    _createElementVNode("span", null, "以下、未読", -1)
                                                                ])))
                                                                : (_openBlock(), _createElementBlock("div", _hoisted_26))
                                                        ], 64))
                                                        : _createCommentVNode("", true),
                                                    (reply.user.role === _unref(AuthRole).MENTOR)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                            (reply.id !== rewrite.id)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(reply.content), 1))
                                                                : _createCommentVNode("", true),
                                                            (reply.id === rewrite.id)
                                                                ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                                                    key: 1,
                                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((rewrite.content) = $event)),
                                                                    id: `textarea_${reply.id}`,
                                                                    style: { "white-space": "pre-line", "font-size": "1.8rem" }
                                                                }, null, 8, _hoisted_29)), [
                                                                    [_vModelText, rewrite.content]
                                                                ])
                                                                : _createCommentVNode("", true),
                                                            _createElementVNode("div", _hoisted_30, [
                                                                _createTextVNode(_toDisplayString(formatRegistered(reply.created_at)) + " ", 1),
                                                                (showEdit(reply.user.id, reply.is_read, reply.id))
                                                                    ? (_openBlock(), _createElementBlock("a", {
                                                                        key: 0,
                                                                        onClick: _withModifiers(($event) => (onClickSetEdit(reply.id, reply.content)), ["prevent"]),
                                                                        class: "bt_change"
                                                                    }, " 編集 ", 8, _hoisted_31))
                                                                    : _createCommentVNode("", true),
                                                                (reply.id === rewrite.id)
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                        _createElementVNode("a", {
                                                                            class: "bt_change",
                                                                            onClick: _withModifiers(onRewrite, ["prevent"])
                                                                        }, "返信"),
                                                                        _createElementVNode("a", {
                                                                            class: "bt_change",
                                                                            onClick: _withModifiers(onClickCancelEdit, ["prevent"])
                                                                        }, "キャンセル")
                                                                    ], 64))
                                                                    : _createCommentVNode("", true)
                                                            ])
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                            _createElementVNode("div", _hoisted_33, [
                                                                _createVNode(ImageFrame, {
                                                                    src: reply.user.photo
                                                                }, null, 8, ["src"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_34, [
                                                                (reply.id !== rewrite.id)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(reply.content), 1))
                                                                    : _createCommentVNode("", true),
                                                                (reply.id === rewrite.id)
                                                                    ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                                                        key: 1,
                                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((rewrite.content) = $event)),
                                                                        id: `textarea_${reply.id}`,
                                                                        style: { "white-space": "pre-line", "font-size": "1.8rem" }
                                                                    }, null, 8, _hoisted_36)), [
                                                                        [_vModelText, rewrite.content]
                                                                    ])
                                                                    : _createCommentVNode("", true),
                                                                _createElementVNode("div", _hoisted_37, [
                                                                    _createTextVNode(_toDisplayString(formatRegistered(reply.created_at)) + " ", 1),
                                                                    (showEdit(reply.user.id, reply.is_read, reply.id))
                                                                        ? (_openBlock(), _createElementBlock("a", {
                                                                            key: 0,
                                                                            onClick: _withModifiers(($event) => (onClickSetEdit(reply.id, reply.content)), ["prevent"]),
                                                                            class: "bt_change"
                                                                        }, " 編集 ", 8, _hoisted_38))
                                                                        : _createCommentVNode("", true),
                                                                    (reply.id === rewrite.id)
                                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                            _createElementVNode("a", {
                                                                                class: "bt_change",
                                                                                onClick: _withModifiers(onRewrite, ["prevent"])
                                                                            }, "返信"),
                                                                            _createElementVNode("a", {
                                                                                class: "bt_change",
                                                                                onClick: _withModifiers(onClickCancelEdit, ["prevent"])
                                                                            }, "キャンセル")
                                                                        ], 64))
                                                                        : _createCommentVNode("", true)
                                                                ])
                                                            ])
                                                        ]))
                                                ], 64));
                                            }), 256)),
                                            (props.answer.evaluation_comments)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                    _createElementVNode("div", _hoisted_40, [
                                                        _createVNode(ImageFrame, {
                                                            src: props.answer.question.user.photo
                                                        }, null, 8, ["src"])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_41, [
                                                        _createElementVNode("div", _hoisted_42, [
                                                            _cache[7] || (_cache[7] = _createElementVNode("p", { style: { "font-weight": "bold" } }, "評価コメント", -1)),
                                                            _createTextVNode(" " + _toDisplayString(props.answer.evaluation_comments), 1)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_43, _toDisplayString(formatRegistered(props.answer.created_at)), 1)
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        (props.answer.locked)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, " メンターの投稿は利用規約に違反しているため無効化されました "))
                                            : _createCommentVNode("", true),
                                        _withDirectives(_createElementVNode("div", _hoisted_45, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((content).value = $event)),
                                                placeholder: showPlaceholder(),
                                                id: "textarea_reply",
                                                oninput: "resizeTextarea('reply',3)"
                                            }, null, 8, _hoisted_46), [
                                                [_vModelText, content.value]
                                            ]),
                                            _createElementVNode("button", {
                                                onClick: _withModifiers(onReply, ["prevent"]),
                                                disabled: disableReply.value,
                                                style: { "cursor": "pointer" }
                                            }, "返信", 8, _hoisted_47)
                                        ], 512), [
                                            [_vShow, showReplyForm.value]
                                        ]),
                                        (props.common.role === _unref(AuthRole).ADMIN && !props.answer.locked)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 1,
                                                class: "breach",
                                                onClick: toggleLock
                                            }, "このメンターの違反として回答無効化"))
                                            : _createCommentVNode("", true),
                                        (props.common.role === _unref(AuthRole).ADMIN && props.answer.locked)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 2,
                                                class: "breach",
                                                onClick: toggleLock
                                            }, "無効化を解除する"))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", { class: "bt_box" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            id: "submit-button",
                                            class: "bt_back",
                                            onClick: onClickReturn
                                        }, " 戻る ")
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("form", null, [
                        _createElementVNode("div", _hoisted_48, [
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "modal-bg bt_modal_close" }, null, -1)),
                            _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("div", _hoisted_50, [
                                    _createVNode(ImageFrame, { src: "images/common/i_bt_close.svg" })
                                ]),
                                _createElementVNode("div", { class: "pop" }, [
                                    _cache[9] || (_cache[9] = _createElementVNode("h2", null, "回答を削除してよろしいですか？", -1)),
                                    _createElementVNode("div", { class: "bt_box clear" }, [
                                        _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                            _cache[8] || (_cache[8] = _createElementVNode("li", null, [
                                                _createElementVNode("p", { class: "bt_modal_close bt_clear" }, "キャンセル")
                                            ], -1)),
                                            _createElementVNode("li", null, [
                                                _createElementVNode("p", {
                                                    class: "bt_modal_close bt_ok",
                                                    onClick: onClickDestroy
                                                }, "OK")
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
